<template>
  <div class="bg-stand" style="height: 100%">
    <top-header></top-header>
    <div class="update-body">
      <div class="toastr animated animate" v-if="close_toastr"
        :class="{ slideInRight: close_toastr, slideOutRight: !close_toastr }" style="z-index: 100000">
        <h4>
          Success
          <span class="closebtn" @click="closetoastr"> &times; </span>
        </h4>
        <p v-if="password_success">Password updated successfully</p>
        <p v-if="email_success">
          {{ email_success_text }}
        </p>
        <p v-if="data_success">Data updated successfully</p>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-12 profile-title mb-3">
          <h4>Update Profile</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-3 update-body-nav">
          <ul>
            <li :class="{ active: tab == 'information' }" @click="setTab('information')">
              <img src="@/assets/User.svg" width="18px" height="18px" v-if="tab != 'information'" />
              <img src="@/assets/User - Active.svg" width="18px" height="18px" v-if="tab == 'information'" />
              &nbsp; Information
            </li>
            <li :class="{ active: tab == 'password' }" @click="setTab('password')">
              <img src="@/assets/Padlock.svg" width="18px" height="18px" v-if="tab != 'password'" />
              <img src="@/assets/Padlock - Active.svg" width="18px" height="18px" v-if="tab == 'password'" />
              &nbsp; Change Password
            </li>
            <template v-if="$store.getters.USER_PLAN != 1">
              <li :class="{ active: tab == 'security' }" @click="setTab('security')">
                <img src="@/assets/Shield.svg" width="18px" height="18px" v-if="tab != 'security'" />
                <img src="@/assets/Shield - Active.svg" width="18px" height="18px" v-if="tab == 'security'" />
                &nbsp; Security
              </li>
            </template>
          </ul>
        </div>
        <div class="col-sm-12 col-md-9">
          <div class="row">
            <div class="col-sm-12 col-md-3 text-center">
              <span class="user" v-if="tab == 'information'">
                <span v-if="!$store.getters.PHOTO" @click="changepic" class="trigger_pic">
                  <i class="fa fa-user-circle" style="font-size: 70px"></i>
                </span>
                <span v-if="$store.getters.PHOTO" @click="changepic" class="trigger_pic_self">
                  <img :src="$store.getters.PHOTO" />
                </span>
                <input type="file" ref="pix" class="pic" @change="showImageInModal" />
              </span>
              <span v-if="tab == 'password'">
                <img src="@/assets/Big_Icon_Pedlock.svg" />
              </span>
              <span v-if="tab == 'security'">
                <img src="@/assets/Big_Icon_Shield.svg" />
              </span>
            </div>
            <div class="col-sm-12 col-md-9">
              <template v-if="tab == 'information'">
                <div class="row mb-3">
                  <div class="col-sm-12 col-md-6">
                    <label>First Name</label>
                    <input type="text" name="firstname" v-model="firstname" placeholder="First Name" />
                    <span class="err" v-if="error.firstname">*Required</span>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <label>Last Name</label>
                    <input type="text" name="lastname" v-model="lastname" placeholder="Last Name" />
                    <span class="err" v-if="error.lastname">*Required</span>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-sm-12 col-md-12">
                    <label>Email</label>
                    <input type="text" name="email" v-model="email" placeholder="Email" />
                    <span class="err" v-if="error.email">*Required</span>
                    <span class="err" v-if="error.valid">Please enter a valid email address</span>
                    <span class="err" v-if="error.exist">{{
                      email + " is already in use"
                    }}</span>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-sm-12 col-md-12">
                    <label>Phone</label>
                    <div class="row">
                      <div class="col-sm-12 col-md-2 phone-mobile">
                        <select v-model="code">
                          <option value="">Select Country</option>
                          <option v-for="(country, index) in countries" :value="country.dial_code" :key="index">
                            {{ country.name }}
                          </option>
                        </select>
                        <span class="err" v-if="error.code">*Required</span>
                      </div>
                      <div class="col-sm-12 col-md-10">
                        <input type="text" placeholder="Phone" v-model="phone" />
                        <span class="err" v-if="error.phone">*Required</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-3" v-if="$store.getters.ACCT_TYPE == 2">
                  <div class="col-sm-12 col-md-12">
                    <label>Department</label>
                    <div class="row">
                      <div class="col-sm-12 col-md-12">
                        <select v-model="department" @change="select">
                          <option value="None">Select Department</option>
                          <option v-for="(deprt, index) in departments" :value="deprt._id" :key="index" selected>
                            {{ deprt.name }}
                          </option>
                        </select>
                        <span class="err" v-if="error.department">*Required</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-12 mt-4">
                    <span class="save-btn" @click="save_data">
                      Save Changes
                    </span>
                    <span class="loader" v-if="data_loader">
                      <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" viewBox="0 0 100 100"
                        width="40px" height="40px" class="lds-dual-ring" style="
                                                                                                          background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;
                                                                                                        ">
                        <circle cx="50" cy="50" fill="none" stroke-linecap="round" stroke="#039aed" r="30"
                          stroke-dasharray="41.41592653589793 41.41592653589793" stroke-width="8">
                          <animateTransform attributeName="transform" type="rotate" calcMode="linear"
                            values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite">
                          </animateTransform>
                        </circle>
                      </svg>
                      Please wait...
                    </span>
                  </div>
                </div>
              </template>
              <template v-if="tab == 'password'">
                <div class="row mb-3">
                  <div class="col-sm-12 col-md-12">
                    <label>Current Password</label>
                    <input type="password" v-model="password" name="password" placeholder="Current Password" />
                    <span class="err" v-if="error.password">*Required</span>
                    <span class="err" v-if="error.wrong">Password is incorrect</span>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-sm-12 col-md-12">
                    <label>New Password</label>
                    <input type="password" v-model="new_password" name="new_password" placeholder="New Password" />
                    <span class="err" v-if="error.new_password">*Required</span>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-sm-12 col-md-12">
                    <label>Confirm New Password</label>
                    <input type="password" v-model="confirm_password" name="confirm_password"
                      placeholder="Confirm New Password" />
                    <span class="err" v-if="error.confirm_password">*Required</span>
                    <span class="err" v-if="error.mismatch">Password mismatched. New Password must match confirm
                      password</span>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-12 mt-4">
                    <span class="save-btn" @click="change_password">
                      Change Password
                    </span>
                    <span class="loader" v-if="password_loader">
                      <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" viewBox="0 0 100 100"
                        width="40px" height="40px" class="lds-dual-ring" style="
                                                                                                          background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;
                                                                                                        ">
                        <circle cx="50" cy="50" fill="none" stroke-linecap="round" stroke="#039aed" r="30"
                          stroke-dasharray="41.41592653589793 41.41592653589793" stroke-width="8">
                          <animateTransform attributeName="transform" type="rotate" calcMode="linear"
                            values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite">
                          </animateTransform>
                        </circle>
                      </svg>
                      Please wait...
                    </span>
                  </div>
                </div>
              </template>
              <template v-if="$store.getters.USER_PLAN != 1">
                <template v-if="tab == 'security'">
                  <template v-if="security_question">
                    <div class="row mb-4">
                      <div class="col-sm-12 col-md-8">
                        <h6>Security Question On</h6>
                      </div>
                      <div class="col-sm-12 col-md-4">
                        <label class="switch">
                          <input type="checkbox" @change="switchtoggle" ref="box" />
                          <span class="slider round">
                            <span class="on" v-if="toggle == 'true'">ON</span><span class="off"
                              v-if="toggle == 'false'">OFF</span>
                          </span>
                        </label>
                      </div>
                    </div>
                    <div class="row mb-4">
                      <div class="col-sm-12 col-md-12">
                        <h6>Security Question Answer</h6>
                        <p>
                          Enter your email address to request link. The link will
                          be use to update your answer
                        </p>
                      </div>
                    </div>
                    <div class="row mb-4">
                      <div class="col-sm-12 col-md-12">
                        <input type="text" v-model="security_email" placeholder="Enter your email address" />
                        <span class="err" v-if="error.security_email">*Required</span>
                        <span class="err" v-if="error.security_email_valid">*Please enter a vaild email</span>
                        <span class="err" v-if="error.security_email_exist">*Email does not exist</span>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col-sm-12 col-md-12 mt-4">
                        <span class="save-btn" @click="send_email">
                          Send Link
                        </span>
                        <span class="loader" v-if="email_loader">
                          <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" viewBox="0 0 100 100"
                            width="40px" height="40px" class="lds-dual-ring" style="
                                                                                                              background: rgba(0, 0, 0, 0) none repeat scroll 0%
                                                                                                                0%;
                                                                                                            ">
                            <circle cx="50" cy="50" fill="none" stroke-linecap="round" stroke="#039aed" r="30"
                              stroke-dasharray="41.41592653589793 41.41592653589793" stroke-width="8">
                              <animateTransform attributeName="transform" type="rotate" calcMode="linear"
                                values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite">
                              </animateTransform>
                            </circle>
                          </svg>
                          Please wait...
                        </span>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <h3>Set your security question.</h3>
                    <p>Secure your account one step better by setting a 2FA. <br />You can turn on/off 2FA on your
                      settings page.</p>
                    <form @keypress="sendquestion" @submit.prevent>
                      <div class="mt-2">
                        <label class="mb-0">Security Question</label>
                        <input type="text" v-model="new_question" placeholder="Enter your security question">
                        <span class="error" v-if="error.question">Please enter your choosen security question</span>
                      </div>
                      <div class="mt-2">
                        <label class="mb-0">Your Answer</label>
                        <input type="password" v-model="new_answer" placeholder="Security question answer">
                        <span class="error" v-if="error.answer">Please enter your security question answer</span>
                      </div>
                      <div class="submit d-flex justify-content-between flex-row mt-3">
                        <span class="save-btn" type="button" @click="submit">Continue</span>
                      </div>
                    </form>
                  </template>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <login ref="login"></login>
    <loading ref="loading"></loading>
    <notify ref="notify"></notify>
    <updatename ref="updatename"></updatename>
    <updateemail ref="updateemail"></updateemail>
    <updatedepartment ref="updatedepartment"></updatedepartment>
    <updatephone ref="updatephone"></updatephone>
    <updatepassword ref="updatepassword"></updatepassword>
    <updateanswer ref="updateanswer"></updateanswer>
    <startupload ref="startupload"></startupload>
    <embeded ref="embed"></embeded>
    <logout ref="logout"></logout>

    <div>
      <b-modal ref="image-crop-modal" id="image-crop-modal" hide-footer no-close-on-backdrop>
        <template v-slot:modal-title> Crop the image </template>
        <div class="d-block">
          <b-img :src="imageToCrop" ref="image-to-crop" fluid-grow alt="Fluid-grow image"></b-img>
        </div>
        <div class="mt-3">
          <div class="container-fluid p-1">
            <div class="row">
              <div class="col-6">
                <button @click="hideModal()" class="btn btn-secondary btn-block">
                  Cancel
                </button>
              </div>
              <div class="col-6">
                <button @click="uploadImage" class="btn btn-primary btn-upload btn-block">
                  Upload
                </button>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <invite ref="invite"></invite>
  </div>
</template>
<style scoped>
.error {
  font-size: 14px;
  color: #c33;
}

.toastr {
  position: absolute;
  background-color: #1db95b;
  box-shadow: rgba(0, 0, 0, 0.3) 0 0 5px 0;
  color: #fff;
  border-radius: 3px;
  padding: 0.8em 1em;
  font-family: "heebo-regular";
  top: 60px;
  right: 12px;
  text-align: left;
  width: 320px;
}

.toastr h4 {
  font-family: "heebo-medium";
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  margin: 0;
}

.toastr .closebtn {
  font-family: "heebo-medium";
  cursor: pointer;
  font-size: 22px;
}

.toastr p {
  color: #fff;
  font-size: 13px;
  margin-bottom: 0;
}

.bg-stand {
  height: auto !important;
}

.err {
  color: #fc6d6c;
  font-size: 13px;
}

.btn-upload {
  background-color: #1e6abb;
}

.security-question-setting span.text {
  display: inline-block;
  margin-right: 1em;
  margin-top: -0.5em;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 22px;
}

.slider .on {
  color: #eee;
  display: block;
  font-weight: bold;
  font-size: 13px;
  margin-left: 0.4em;
  margin-top: 0.18em;
}

.slider .off {
  color: #999;
  display: block;
  font-weight: bold;
  margin-right: 0.3em;
  font-size: 12px;
  margin-top: 0.18em;
  text-align: right;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 6px;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 0.1em;
  top: 0.17em;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked+.slider {
  background-color: #2196f3;
}

input:focus+.slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked+.slider:before {
  -webkit-transform: translateX(36px);
  -ms-transform: translateX(36px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 100px;
}

.slider.round:before {
  border-radius: 50%;
}

.table {
  display: flex;
  justify-content: space-evenly;
}

.table table {
  width: 60%;
}

.table table th {
  font-weight: bold;
  font-size: 24px;
  border: none;
}

.table table tr td {
  border-bottom: 1px solid #e0dede;
  padding: 0.5em !important;
  position: relative;
}

.table table tr td a {
  cursor: pointer;
  color: #069;
  font-size: 14px;
}

.table table tr td a:hover {
  color: #069;
}

.loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

button {
  outline: none;
}

.department {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.8em;
}

.department select {
  border: 1px solid #e1e1e1;
  padding: 0.8em 0.5em;
}

.assign {
  display: flex;
  flex-direction: row;
  font-size: 13px;
}

.assign input {
  margin-right: 0.4em;
}

.add-department .error {
  color: #fc6d6c;
}

.form {
  background: #f9f9f97e url("../../public/bg.png");
  height: calc(100% - 160px);
  text-align: left;
  padding: 1em;
}

.form ul li {
  display: flex;
  justify-content: space-evenly;
  margin-bottom: 20px;
}

.actions {
  display: flex;
  justify-content: space-around;
}

.actions button {
  border: none;
  border-radius: 5px;
  padding: 0.7em 1.5em;
  font-size: 14px;
  color: #fff;
  box-shadow: rgba(0, 0, 0, 0.3) 0 3px 4px 0;
  outline: none;
}

.actions .approve_btn {
  background-color: #0071e0;
}

.actions .approve_btn:hover {
  background-color: rgb(4, 84, 165);
}

.actions .decline_btn {
  background-color: rgb(224, 52, 0);
}

.actions .decline_btn:hover {
  background-color: rgb(158, 35, 4);
}

.form .add-department {
  width: 30%;
}

.form .add-department h4 {
  font-weight: bold;
}

.form input[type="text"] {
  width: 100%;
  border: 1px solid #f1f1f1;
  border-radius: 3px;
  padding: 1em 1em;
}

.form .btn {
  cursor: pointer;
  background: #0071e0;
  color: #fff;
  border-radius: 3px;
  padding: 1em 1em;
  display: inline-block;
  text-align: center;
  width: 100%;
}

.top-header {
  border-bottom: 1px solid #f9f9f9;
}

.undraw {
  width: 18%;
}

.undraw img {
  max-width: 100%;
}

.bottom-pane {
  text-align: left;
}

.listed-department {
  background: #fff;
  padding: 1em;
  width: 35%;
  height: auto;
}

.listed-department li {
  display: flex;
  align-items: center;
}

.listed-department li span {
  margin-left: 0.4em;
}

.bottom-pane h1 {
  font-size: 50px;
  font-weight: bold;
  color: #000;
}

p {
  margin: 0;
}

.add-department p:first-child {
  margin-bottom: 0.6em !important;
}

.bottom-pane {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding-top: 0.9em;
}
</style>

<script>
import loading from "@/components/Loading";
import TopHeader from "@/components/Top-Header";
import logout from "@/components/Logout";
import { mapMutations } from "vuex";
import notify from "@/components/Notify";
import login from "@/components/Login";
import updatename from "@/components/Update-Name";
import updateemail from "@/components/Update-Email";
import updatephone from "@/components/Update-User-Phone";
import updatepassword from "@/components/Update-Password";
import updateanswer from "@/components/Update-Answer";
import updatedepartment from "@/components/Update-Department";
import startupload from "@/components/Start-Upload";
import cookies from "@/services/cookies";
import "cropperjs/dist/cropper.css";
import Cropper from "cropperjs";
import countries from "@/countries";
import embeded from "@/components/Embed";
import invite from '@/components/Invite';
import AuthenticationService from '../services/AuthenticationService'
export default {
  components: {
    notify,
    login,
    TopHeader,
    loading,
    updatename,
    updateemail,
    updatephone,
    updatepassword,
    updateanswer,
    updatedepartment,
    startupload,
    embeded,
    invite,
    logout,
  },
  data() {
    return {
      hidden: true,
      cropper: Object,
      imageToCrop: "",
      answer: "",
      error: {
        firstname: false,
        lastname: false,
        email: false,
        code: false,
        department: false,
        password: false,
        new_password: false,
        confirm_password: false,
        security_email: false,
        mismatch: false,
        wrong: false,
        exist: false,
        valid: false,
        question: false,
        answer: false,
        security_email_valid: false,
        security_email_exist: false,
      },
      folders: [],
      group_folder_request: [],
      name: "",
      code: "",
      post: true,
      restrict: false,
      approved_group_folder: [],
      approved_folder: [],
      group_folder: [],
      user_profile: [],
      countries: countries,
      departments: [],
      department: "",
      firstname: "",
      lastname: "",
      phone: "",
      email: "",
      security_email: "",
      password: "",
      new_password: "",
      confirm_password: "",
      tab: "information",
      switchtext:
        localStorage.getItem("is_security_question") == "true" ||
          localStorage.getItem("is_security_question") == undefined
          ? "Security Question On"
          : "Security Question Off",
      toggle: localStorage.getItem("is_security_question"),
      password_loader: false,
      email_loader: false,
      data_loader: false,
      close_toastr: false,
      email_success: false,
      data_success: false,
      password_success: false,
      email_success_text: "",
      image_file: '',
      security_question: "",
      account_type: null,
      new_question: "",
      new_answer: "",
      str: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    };
  },
  methods: {
    ...mapMutations([
      "SET_FILE_ACTION",
      "REMOVE_FILE_ACTION",
      "SET_DIRECTORY_CHILDREN",
      "TOGGLE_FILE_INFO",
      "SORT_DIRECTORY_CHILDREN",
      "SORT_STORED_DIRECTORY_CHILDREN",
      "SET_STORED_DIRECTORY_CHILDREN",
      "GET_DIRECTORY_CHILDREN",
      "CLOSE_FILE_INFO",
      "SET_PATH",
      "UPDATE_SLIDEIN",
      "UPDATE_SLIDEOUT",
      "UPDATE_BODY_MENU",
      "UPDATE_MENU",
      "UPDATE_TOTAL_CREATED_IMAGES",
      "UPDATE_TOTAL_CREATED_DOCUMENTS",
      "UPDATE_TOTAL_CREATED_FOLDERS",
      "SET_FIRSTNAME",
      "SET_LASTNAME",
      "SET_EMAIL",
      "SET_PHONE",
      "SET_POSITION",
      "SET_DEPARTMENT",
      "SET_COUNTRY",
      "SET_DATE_CREATED",
      "SET_ACCT_TYPE",
      "SET_ISADMIN",
      "SET_PHOTO",
      "UPDATE_TOTAL_SPACE",
      "UPDATE_DEFAULT_FOLDER",
      "UPDATE_TOTAL_USED_SPACE",
      "SET_ISTRIAL",
      "SET_ISSTAFF",
      "SET_ISSUPERADMIN",
      "SET_PATH",
      "SORT_DIRECTORY_CHILDREN",
      "SET_CURRENT_DIRECTORY",
      "HIDE_FILE_INFO",
      "SET_FILE_ACTION",
      "SET_SELECT_ALL",
      "SET_CURRENT_PLAN",
      "UPDATE_PUBLIC_FOLDER_ID",
      "SET_USER_PLAN",
      "UPDATE_USER",
      "SET_NAME",
      "SET_IS_SECURITY_QUESTION",
      "SET_PLAN_STATUS",
      "SET_TRIAL_STATUS",
      "SET_HAS_CRM",
      "SET_HAS_INVEX",
      "SET_INVEX_DOMAIN",
      "SET_INVEX_API_URL"
    ]),
    sendquestion(evt) {
      if (evt.keyCode === 13) {
        this.post = true

        if (this.new_question === '') {
          this.post = false
          this.error.question = true
        } else {
          this.error.question = false
        }

        if (this.new_answer === '') {
          this.post = false
          this.error.answer = true
        } else {
          this.error.answer = false
        }

        if (this.post) {
          this.$refs.loading.load()
          let that = this
          let data = {
            security_question: this.new_question,
            question_answer: this.new_answer,
            token: cookies.getCookie('token'),
            account_type: this.account_type
          }

          AuthenticationService.setsecurity(data).then(res => {
            if (res.data.data == true) {
              localStorage.setItem("is_security_question", true)
              that.toggle = true
              that.close_toastr = true;
              that.security_question = that.new_question
              that.$refs.loading.close()
              setTimeout(() => {
                that.$refs.box.checked = true
                that.close_toastr = false;
              }, 3000)
            }

            if (res.data.result == false) {
              that.$router.push('login')
            }
          }).catch(err => {
            console.log(err)
          })
        }
      }
    },
    submit() {
      this.post = true

      if (this.new_question === '') {
        this.post = false
        this.error.question = true
      } else {
        this.error.question = false
      }

      if (this.new_answer === '') {
        this.post = false
        this.error.answer = true
      } else {
        this.error.answer = false
      }

      if (this.post) {
        this.$refs.loading.load()
        let that = this
        let data = {
          security_question: this.new_question,
          question_answer: this.new_answer,
          token: cookies.getCookie('token'),
          account_type: this.account_type
        }

        AuthenticationService.setsecurity(data).then(res => {
          if (res.data.data == true) {
            localStorage.setItem("is_security_question", true)
            that.toggle = true
            that.close_toastr = true;
            that.security_question = that.new_question
            that.$refs.loading.close()
            setTimeout(() => {
              that.$refs.box.checked = true
              that.close_toastr = false;
            }, 3000)
          }

          if (res.data.result == false) {
            that.$router.push('login')
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    hideModal() {
      this.$refs["image-crop-modal"].hide();
    },
    invite() {
      this.$refs.invite.load()
    },
    closetoastr() {
      this.close_toastr = false;
      this.password_success = false;
      this.email_success = false;
      this.data_success = false;
    },
    setTab(tab) {
      this.tab = tab;

      this.error.firstname = false;
      this.error.lastname = false;
      this.error.email = false;
      this.error.code = false;
      this.error.department = false;
      this.error.password = false;
      this.error.new_password = false;
      this.error.confirm_password = false;
      this.error.security_email = false;
      this.error.mismatch = false;
      this.error.wrong = false;
      this.error.exist = false;
      this.error.valid = false;
      this.error.question = false
      this.error.answer = false

      if (tab == "security") {
        let that = this;
        setTimeout(function () {
          if (that.security_question == '') {
            return
          }

          if (
            localStorage.getItem("is_security_question") == "true" ||
            localStorage.getItem("is_security_question") == undefined
          ) {
            that.$refs.box.checked = true;
          } else {
            that.$refs.box.checked = false;
          }

          this.toggle = localStorage.getItem("is_security_question");
        }, 100);
      }
    },
    send_email() {
      let post = true;
      this.error.security_email_exist = false;
      if (this.security_email == "") {
        this.error.security_email = true;
        post = false;
      } else {
        this.error.security_email = false;

        if (this.str.test(this.security_email) === false) {
          this.error.security_email_valid = true;
          post = false;
        } else {
          this.error.security_email_valid = false;
        }
      }

      if (post) {
        this.email_loader = true;
        let that = this;

        let data = {
          token: cookies.getCookie("token"),
          email: this.security_email,
        };

        this.$socket.emit("send-update-link", data, function (data) {
          if (data.data === true) {
            that.email_loader = false;
            that.email_success_text =
              "A link has been sent to " + that.security_email;
            that.security_email = "";
            that.close_toastr = true;
            that.email_success = true;
            setTimeout(() => {
              that.close_toastr = false;
              that.email_success = false;
            }, 3000);
          }

          if (data.exist === true) {
            that.email_loader = false;
            that.security_email = "";
            that.error.security_email_exist = true;
            setTimeout(() => {
              that.error.security_email_exist = false;
            }, 2000);
          }

          if (data.data === false) {
            that.security_email = "";
            that.email_loader = false;
            that.logincall();
          }
        });
      }
    },
    change_password() {
      this.post = true;
      this.error.wrong = false;
      this.error.mismatch = false;

      if (this.password == "") {
        this.error.password = true;
        this.post = false;
      } else {
        this.error.password = false;
      }

      if (this.new_password == "") {
        this.error.new_password = true;
        this.post = false;
      } else {
        this.error.new_password = false;
      }

      if (this.confirm_password == "") {
        this.error.confirm_password = true;
        this.post = false;
      } else {
        this.error.confirm_password = false;
      }

      if (this.new_password != this.confirm_password) {
        this.error.mismatch = true;
        this.post = false;
      } else {
        this.error.mismatch = false;
      }

      if (this.post) {
        this.password_loader = true;
        let that = this;

        let data = {
          token: cookies.getCookie("token"),
          invextoken: cookies.getCookie('invextoken'),
          old_password: this.password,
          password: this.new_password,
        };

        this.$socket.emit("update-password", data, function (data) {
          if (data.data === true) {
            that.password_loader = false;
            that.password = "";
            that.new_password = "";
            that.confirm_password = "";
            that.close_toastr = true;
            that.password_success = true;

            setTimeout(() => {
              that.close_toastr = false;
              that.password_success = false;
            }, 3000);
          }

          if (data.data === "not exist") {
            that.password_loader = false;
            that.error.wrong = true;
          }

          if (data.data === false) {
            that.password_loader = false;
            that.old_password = "";
            that.new_password = "";
            that.confirm_password = "";
            that.logincall();
            that.$router.push('/login')
          }
        });
      }
    },
    save_data() {
      let post = true;

      if (this.firstname == "" || this.firstname == null) {
        this.error.firstname = true;
        post = false;
      } else {
        this.error.firstname = false;
      }

      if (this.lastname == "" || this.lastname == null) {
        this.error.lastname = true;
        post = false;
      } else {
        this.error.lastname = false;
      }

      if (this.email == "") {
        this.error.email = true;
        post = false;
      } else {
        this.error.email = false;

        if (this.str.test(this.email) === false) {
          this.error.valid = true;
          post = false;
        } else {
          this.error.valid = false;
        }
      }

      if (this.phone != "" && this.phone != null) {
        if (this.code == "" || this.code == null) {
          post = false;
          this.error.code = true;
        } else {
          this.error.code = false;
        }
      } else {
        this.error.code = false;
      }

      if (this.code != "" && this.code != null) {
        if (this.phone == "" || this.phone == null) {
          post = false;
          this.error.phone = true;
        } else {
          this.error.phone = false;
        }
      } else {
        this.error.phone = false;
      }

      if (this.$store.getters.ACCT_TYPE == 2) {
        if (!this.$store.getters.ISADMIN) {
          if (this.department == "") {
            post = false;
            this.error.department = true;
          } else {
            this.error.department = false;
          }
        }
      }

      if (post) {
        this.data_loader = true;
        let that = this;

        let data = {
          token: cookies.getCookie("token"),
          email: this.email,
          firstname: this.firstname,
          lastname: this.lastname,
          code: this.code,
          phone: this.phone,
          department: this.department == "None" ? "" : this.department,
        };

        this.$socket.emit("update-data", data, function (data) {
          if (data.data === true) {
            that.data_loader = false;

            that.close_toastr = true;
            that.data_success = true;

            setTimeout(() => {
              that.close_toastr = false;
              that.data_success = false;
            }, 3000);
          }

          if (data.data === "exist") {
            that.data_loader = false;
            that.error.exist = true;
          }

          if (data.data === false) {
            that.data_loader = false;
            that.logincall();
            that.$router.push('/login')
          }
        });
      }
    },
    select() {
      if (this.department == "None") {
        this.error.department = true;
      } else {
        this.error.department = false;
      }
    },
    showImageInModal(e) {
      const files = e.target.files;
      // this.image_file = e.target.files
      if (files && files.length > 0) {
        const file = files[0];
        if (URL) {
          this.done(URL.createObjectURL(file));
        } else if (FileReader) {
          const reader = new FileReader();
          reader.onload = () => {
            this.done(reader.result);
          };
          reader.readAsDataURL(file);
        }
      }
      this.$refs["image-crop-modal"].show();
    },
    done(url) {
      this.$refs["pix"].value = "";
      this.imageToCrop = url;
    },
    uploadImage() {
      if (this.cropper) {
        const canvas = this.cropper.getCroppedCanvas({
          width: 160,
          height: 160,
        });
        canvas.toBlob((blob) => {
          const file = new File([blob], "photo.jpeg", { type: '"image/jpeg"' });
          // const file2 = new File([this.image_file[0]], 'big_image.jpeg', { type: '"image/jpeg"' })
          this.$refs.startupload.load(file, false);
          // if success set image and hide modal
          // this.$refs['current-image'].src = canvas.toDataURL()
          this.$refs["image-crop-modal"].hide();
        });
      }
    },
    switchtoggle(evt) {
      if (evt.target.checked) {
        this.toggle = "true";
        this.$refs.checked = true;
        let data = {
          token: cookies.getCookie("token"),
          state: true,
        };
        this.switchtext = "Security Question On";
        let that = this;
        this.$socket.emit("question-state", data, function (data) {
          if (data.data === true) {
            that.SET_IS_SECURITY_QUESTION(true);
            localStorage.setItem("is_security_question", true);
          }
          if (data.data === false) {
            that.$router.push('/login')
          }
        });
      } else {
        this.toggle = "false";
        this.$refs.checked = false;
        let data = {
          token: cookies.getCookie("token"),
          state: false,
        };
        this.switchtext = "Security Question Off";
        let that = this;
        this.$socket.emit("question-state", data, function (data) {
          if (data.data === true) {
            that.SET_IS_SECURITY_QUESTION(false);
            localStorage.setItem("is_security_question", false);
          }
          if (data.data === false) {
            that.$router.push('/login')
          }
        });
      }
    },
    change_pic() {
      this.UPDATE_SLIDEIN(false);
      this.UPDATE_SLIDEOUT(true);
      this.UPDATE_MENU(false);
      this.UPDATE_BODY_MENU(false);
      this.$refs.pic.click();
    },
    changepic() {
      this.$refs.pix.click();
    },
    startupload() {
      this.$refs.startupload.load(this.$refs.pix.files[0], false);
      this.$refs.pix.value = "";
    },
    start_upload() {
      this.$refs.startupload.load(this.$refs.pic.files[0]);
      this.$refs.pic.value = "";
    },
    slideout($evt) {
      if ($evt.target.tagName === "svg" || $evt.target.tagName === "path") {
        this.UPDATE_SLIDEIN(false);
        this.UPDATE_SLIDEOUT(true);
        this.UPDATE_MENU(false);
        this.UPDATE_BODY_MENU(false);
      } else {
        if ($evt.target.classList.contains("menubody")) {
          this.UPDATE_SLIDEIN(false);
          this.UPDATE_SLIDEOUT(true);
          this.UPDATE_MENU(false);
          this.UPDATE_BODY_MENU(false);
        }
      }
    },
    logincall() {
      this.$refs.login.load();
    },
    check(evt) {
      if (evt.target.value !== "") {
        this.error = false;
      }
    },
    update_answer() {
      this.$refs.updateanswer.load();
    },
    update_password() {
      this.$refs.updatepassword.load();
    },
    update_phone(phone, code) {
      this.$refs.updatephone.load(phone, code);
    },
    update_department(department, department_id) {
      this.$refs.updatedepartment.load(department, department_id);
    },
    update_email(email) {
      this.$refs.updateemail.load(email);
    },
    update_name(firstname, lastname) {
      this.$refs.updatename.load(firstname, lastname);
    },
    updateName(firstname, lastname) {
      this.user_profile.firstname = firstname;
      this.user_profile.lastname = lastname;
      this.$refs.notify.load("Name updated successfully");
    },
    updateEmail(email) {
      this.user_profile.email = email;
      this.$refs.notify.load("Email updated successfully");
    },
    updatePhone(phone, code, new_phone) {
      this.user_profile.full_phone = phone;
      this.user_profile.code = code;
      this.user_profile.phone = new_phone;
      this.$refs.notify.load("Phone updated successfully");
    },
    updateDepartment(department) {
      this.user_profile.department = department;
      this.$refs.notify.load("Department updated successfully");
    },
    updateAnswer() {
      this.$refs.notify.load("Security question answer updated successfully");
    },
    linkSent(msg) {
      this.$refs.notify.load(msg);
    },
    updatePassword() {
      this.$refs.notify.load("Password updated successfully");
    },
    asterick(len) {
      let str = "";
      for (let i = 0; i < len; i++) {
        str += "*";
      }
      return str;
    },
    backlist(str = null) {
      if (str != null) {
        let len = Math.round((str.length / 100) * 50);
        return this.asterick(len) + str.substr(len, str.length - len);
      }
    },
    close() {
      this.error.message = false;
    },
    logout() {
      this.$refs.logout.logout();
    },
    user_data() {
      let data = {
        token: cookies.getCookie("token"),
      };
      let that = this;
      this.$socket.emit("get-data", data, function (data) {
        if (data.data === true) {
          that.SET_ACCT_TYPE(data.account_type);
          that.SET_ISADMIN(data.isSuperAdmin);
          that.SET_FIRSTNAME(data.firstname);
          that.SET_LASTNAME(data.lastname);
          that.SET_NAME(data.firstname + " " + data.lastname);
          that.SET_EMAIL(data.email);
          that.SET_PHONE(data.phone);
          that.SET_POSITION(data.position);
          that.SET_DEPARTMENT(data.department);
          that.SET_COUNTRY(data.country ? data.country : "");
          that.SET_DATE_CREATED(data.date_created);
          that.SET_PHOTO(data.photo);
          that.UPDATE_TOTAL_SPACE(data.total_space);
          that.UPDATE_TOTAL_USED_SPACE(data.total_space_used);
          that.UPDATE_USER(data.id);
          that.SET_CURRENT_PLAN(data.current_plan);
          that.SET_USER_PLAN(data.user_plan);
          that.SET_ISTRIAL(data.isTrial);
          that.SET_ISSTAFF(data.isStaff);
          that.SET_ISSUPERADMIN(data.isSuperAdmin);
          that.SET_IS_SECURITY_QUESTION(data.is_security_question);
          that.UPDATE_DEFAULT_FOLDER(data.default_folders);
          that.UPDATE_PUBLIC_FOLDER_ID(data.public_folder_id);
          localStorage.setItem("email", data.email);
          localStorage.setItem(
            "is_security_question",
            data.is_security_question
          );
          that.SET_HAS_CRM(data.hasCrm);
          that.SET_HAS_INVEX(data.hasInvex);
          that.SET_INVEX_DOMAIN(data.invex_domain);
          that.SET_INVEX_API_URL(data.invex_api_url);
          localStorage.setItem("id", data.id);
          sessionStorage.setItem("gi", data.group_folder_id);
          sessionStorage.setItem("pi", data.project_folder_id);
          that.UPDATE_TOTAL_CREATED_IMAGES(data.total_created_images);
          that.UPDATE_TOTAL_CREATED_DOCUMENTS(data.total_created_documents);
          that.UPDATE_TOTAL_CREATED_FOLDERS(data.total_created_folders);

          that.SET_PLAN_STATUS(data.isPlanActive);
          that.SET_TRIAL_STATUS(data.isTrialActive);
        }

        if (data.data === false) {
          that.$router.push('/login')
        }
      });
    },
  },
  computed: {
    src() {
      return process.env.VUE_APP_NODE_ENV === "development"
        ? "https://192.168.1.2:9009/embed"
        : "https://app.fexspace.com/embed";
    },
  },
  mounted() {
    let that = this;

    this.$socket.emit(
      "get-departments",
      { token: cookies.getCookie("token") },
      function (data) {
        if (data.data == true) {
          that.departments = data.departments;
        }

        if (data.data === false) {
          that.done = false;
          that.loader = false;
          that.seen = false;
          that.logincall();
          that.$router.push('/login')
        }
      }
    );

    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      if (modalId === "image-crop-modal") {
        setTimeout(() => {
          this.cropper = new Cropper(this.$refs["image-to-crop"], {
            aspectRatio: 1,
            viewMode: 3,
          });
        }, 1000);
      }
    });
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      if (modalId === "image-crop-modal") {
        this.cropper.destroy();
        this.cropper = null;
      }
    });
    this.user_data();

    if (
      cookies.getCookie("token") !== "" &&
      cookies.getCookie("token") !== null
    ) {
      let data = {
        token: cookies.getCookie("token"),

      };

      this.$socket.emit(
        "load-user-profile",
        { token: cookies.getCookie("token") },
        function (data) {
          if (data.data === true) {
            that.user_profile = data.user_profile;
            that.name = that.user_profile.firstname + ' ' + that.user_profile.lastname
            that.firstname = that.user_profile.firstname;
            that.lastname = that.user_profile.lastname;
            that.department =
              that.user_profile.department_id == ""
                ? "None"
                : that.user_profile.department_id;
            that.email = that.user_profile.email;
            that.phone = that.user_profile.phone;
            that.security_question = that.user_profile.question
            that.account_type = that.user_profile.account_type
          }
          if (data.data === false) {
            that.$router.push("/login");
          }
        }
      );
    } else {
      this.$router.push("/login");
    }
  },
};
</script>
